import { useState } from 'react'
import { Input } from 'reactstrap'
import { isDisabled } from '../../utils'

export default function AppObjectFieldMultilineText(props) {
  const { field, action, value, handleChange, hasChanged } =  props
  console.log('AppObjectFieldMultilineText rendered: ', props)

  const [text, setText] = useState(value)

  function handleTextChange(event) {
    if (event.target.value.length > field.maxLength) {
      console.log('************************ OVER MAX')
      return false
    }
    setText(event.target.value)
    handleChange(event, hasChanged)
  }

  if (isDisabled(action, field.behaviorType)) {
    return <span style={{ whiteSpace: 'pre-wrap'}}>{text}</span>
  }
  return (
    <Input
      data-cy={`field-${field.id}`}
      type="textarea"
      name={field.id}
      bsSize="sm"
      id={field.id}
      value={text}
      onChange={(event) => handleTextChange(event)}
      rows={field.height}
      cols={field.width}
    />
  )
}
